import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import ArModels from 'api/resources/arModels';
import getErrors from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import RadioList from '../../components/RadioList';

const PAGE_SIZE = 20;

class ARs extends React.PureComponent {
  state = {
    arModels: [],
    loading: false,
    errors: [],

    next: false,
    pageNumber: 0,
  }

  componentDidMount() {
    this.reloadArModels();
  }

  handleItemClick = (id) => {
    this.props.onChangeBlockField(id, 'id');
  }

  handleWaypointEnter = () => { this.loadArModels(); }

  async loadArModels() {
    this.setState({ loading: true, errors: [] });

    try {
      const response = await ArModels.getAll({ page: {
        number: this.state.pageNumber,
        size: PAGE_SIZE,
      } });

      const arModels = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState(prevState => ({
        arModels: prevState.arModels.concat(arModels.map(arModel => ({
          id: arModel.id,
          title: arModel.title,
          content: arModel.title,
        }))),
        loading: false,
        next: arModels.length === PAGE_SIZE,
        pageNumber: prevState.pageNumber + 1,
      }));
    } catch (err) {
      const errors = await getErrors(err);
      this.setState({ errors, loading: false });
    }
  }

  async reloadArModels() {
    this.setState({
      arModels: [],
      loading: true,
      errors: [],

      next: false,
      pageNumber: 0,
    });

    try {
      const response = await ArModels.getAll({ page: {
        number: 0,
        size: PAGE_SIZE,
      } });

      const arModels = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({
        arModels: arModels.map(arModel => ({
          id: arModel.id,
          title: arModel.title,
          content: arModel.title,
        })),
        loading: false,
        next: arModels.length === PAGE_SIZE,
        pageNumber: 1,
      });
    } catch (err) {
      const errors = await getErrors(err);
      this.setState({ errors, loading: false });
    }
  }

  render() {
    return (
      <RadioList
        selectedItemId={this.props.block.get('id')}

        items={this.state.arModels}
        loading={this.state.loading}
        errors={this.state.errors}
        next={this.state.next}
        pageNumber={this.state.pageNumber}

        errorMessages={{
          loading: 'Загрузка списка AR-моделей... 🚚',
          empty: 'AR-модели не найдены 😢',
        }}

        onItemClick={this.handleItemClick}
        onWaypointEnter={this.handleWaypointEnter}
      />
    );
  }
}

ARs.propTypes = {
  block: PropTypes.object,
  onChangeBlockField: PropTypes.func,
};

ARs.defaultProps = {
  block: Map(),
  onChangeBlockField: () => {},
};

export default ARs;
